import { ShipmentDocumentRouteService } from 'common/data';
import { BaseService } from 'core/services';

class ShipmentDocumentService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ShipmentDocumentRouteService());
	}
	upload(files) {
		var url = this.routeService.upload(files);
		return this.apiClient.post(url);
	}

	uploadDocument = async (fulfillmentOrderId, type, data) => {
		const url = this.routeService.uploadDocument(fulfillmentOrderId, type);
		return this.apiClient.post(url, data);
	};

	printDocument = async (fulfillmentOrderId, type) => {
		const url = this.routeService.printDocument(fulfillmentOrderId, type);
		return this.apiClient.get(url);
	};

	getForFulfillmentOrder = async fulfillmentOrderId => {
		const url = this.routeService.getForFulfillmentOrder(fulfillmentOrderId);
		return this.apiClient.get(url);
	};
}

export default ShipmentDocumentService;
